import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';

import { PriceBreakDownViewModel } from 'models';

import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkToolbar } from 'uitk-react-toolbar';

const LinkTracked = ClickTracker(Link);

export interface PriceBreakDownDialogProps {
  priceBreakDownModel: PriceBreakDownViewModel[];
  id: string;
  layerId: string | number;
  childContent: React.ReactNode;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
}
@inject('routeStore', 'analytics')
@observer
export class PriceBreakDownDialog extends React.Component<PriceBreakDownDialogProps> {
  constructor(props) {
    super(props);
    this.onDismiss = this.onDismiss.bind(this);
  }

  private onDismiss() {
    this.props.routeStore.goBack();
  }

  public render() {
    const { priceBreakDownModel, routeStore, analytics, id, layerId, childContent } = this.props;
    const dialogId = `price-breakdown-dialog-${layerId}`;

    if (!priceBreakDownModel || priceBreakDownModel.length === 0 || !childContent) {
      return null;
    }

    const { breakdownHeader } = priceBreakDownModel && priceBreakDownModel.length > 0 && priceBreakDownModel[0];
    const param = id === 'infosite-room-info-dialog-ratePlans' ? { pwaDialogNested: dialogId } : { pwaDialog: dialogId };
    const trackingRfrr = id === 'infosite-room-ratePlans' ? 'RoomsAndRates.PriceDetailDialog' : 'RoomInfo.PriceDetailDialog';
    const query = routeStore.mergeQueryString(routeStore.search, param);
    const toolbarAnalytics = analytics.setupTracker(trackingRfrr, 'Close price details dialog');
    const routeStoreGoBack = () => routeStore.goBack();

    return (
      <>
        <LinkTracked
          to={{ pathname: routeStore.pathname, search: query }}
          className="all-y-padding-two"
          linkName="Open price details dialog"
          rfrr={trackingRfrr}
        >
          {breakdownHeader}
        </LinkTracked>
        <QueryRoute query={param}>
          <Layer id={`pricebreakdown-layer-${layerId}`} onDismiss={routeStoreGoBack}>
            <UitkFullscreenDialog dialogShow={true}>
              <UitkToolbar analytics={toolbarAnalytics} header={breakdownHeader} action={this.onDismiss} iconLabel="close.dialog" />
              <UitkDialogContent zeroPadding={true}>{childContent}</UitkDialogContent>
            </UitkFullscreenDialog>
          </Layer>
        </QueryRoute>
      </>
    );
  }
}
